module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/OOPVSV/media/FC-9781649796417.jpg?1684514594238",
      "alt": "This image is the cover for the book She Howled"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("She Howled\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0mm",
      "margin-right": "0mm",
      "margin-bottom": "8.0pt",
      "margin-left": "0mm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("Walking along the trails and trials of life, there is a story that must come out"), _c('em', [_vm._v(". ")]), _vm._v("In"), _c('em', [_vm._v(" She Howled, ")]), _vm._v("author Anne Julia takes a journey woven into the bones of an old Inn in Vermont, to the shores of a lake and the fog of an ocean, all the while writing her experiences of the world around her into a collection of fictional and non-fictional stories.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Anne Julia\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("The author and his partner Denise have recently moved house, to live in Hertfordshire, on the edge of Ashridge Forest. He works for John Lewis, mainly from home, but still ventures into Central London a couple of days a week. "), _c('br'), _vm._v("He’s an avid Arsenal fan and enjoys cross country running, pubs and Caribbean cooking; and of course, writing. His literary influences include the work of Ellis Peters, T H White, and the Welsh legends of the Mabinogion. "), _c('br'), _vm._v("His dream is to be writing full time from a luxury cabin in the bottom of the garden and to see his work make it onto the big screen.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0